/** @format */

import React, { useState, useEffect, useContext } from "react";
import { Modal, Button, Input, Spin, message } from "antd";
import NotesIcon from "../../../assets/Icons/notes-icon.svg";
import VoiceGainAuthSvcApi from "../../../apis/VoiceGainAuthSvcApi";
import { EditOutlined } from "@ant-design/icons";
import { AccountsOverviewContainerContext } from "./AccountsOverview.container";

interface IAccountsOverviewNotesModalProps {
  accountId: string;
  notes: string;
  isModalVisible: boolean;
  closeModal: () => void;
}

const AccountsOverviewNotesModal: React.FC<
  IAccountsOverviewNotesModalProps
> = ({ accountId, notes, isModalVisible, closeModal }) => {  
  const { updateNotesCache } = useContext(AccountsOverviewContainerContext);
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [isLoadingNotes, setIsLoadingNotes] = useState<boolean>(false);
  const [userNotes, setUserNotes] = useState<string>("");
  const [editedNotes, setEditedNotes] = useState<string>(userNotes);

  const onSubmit = async () => {
    try {
      setIsLoadingNotes(true);
      let modAccountResponse = await VoiceGainAuthSvcApi.modAccount(accountId, {
        notes: editedNotes,
      });
      let modAccountData = await modAccountResponse.json();
      if (modAccountResponse.ok) {
        console.log(modAccountData);
        const savedNotes = modAccountData.notes || editedNotes;
        setUserNotes(savedNotes);
        // Update the in-memory cache with the saved notes
        updateNotesCache(accountId, savedNotes);
        message.success("Notes saved successfully.");
      } else throw new Error("Error adding notes.");
    } catch (err) {
      console.log(err);
      message.error("Error ssving notes.");
    } finally {
      setIsLoadingNotes(false);
    }
  };

  const toggleEdit = (toggle: boolean) => {
    setEditedNotes(userNotes);
    setIsEditing(toggle);
  };

  const saveEdit = (toggle: boolean) => {
    onSubmit();
    setIsEditing(toggle);
  };

  const onChangeInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setEditedNotes(e.target.value);
  };

  useEffect(() => {
    setUserNotes(notes);
  }, [notes]);

  return (
    <Modal
      open={isModalVisible}
      closable={false}
      onCancel={() => closeModal()}
      footer={[
        <Button
          key="closeButton"
          onClick={
            isEditing ? () => toggleEdit(false) : () => closeModal()
          }
        >
          {isEditing ? "Cancel" : "Close"}
        </Button>,
        <Button
          key="editButton"
          onClick={isEditing ? () => saveEdit(false) : () => toggleEdit(true)}
          type="primary"
        >
          {isEditing ? (
            "Done"
          ) : (
            <div>
              Edit <EditOutlined />
            </div>
          )}
        </Button>,
      ]}
    >
      <div>
        {isEditing ? (
          <div style={{ padding: "0.8rem", marginTop: "0.4rem" }}>
            <Input.TextArea
              rows={8}
              onChange={onChangeInput}
              value={editedNotes}
            />
          </div>
        ) : (
          <div>
            {userNotes === "" || userNotes === undefined ? (
              <div style={{ textAlign: "center" }}>
                <div style={{ marginBottom: "1.5rem" }}>
                  <img
                    src={NotesIcon}
                    alt="notes-icon"
                    height="50px"
                    width="50px"
                  />
                </div>
                <div>This user does not have any notes yet.</div>
              </div>
            ) : (
              <Spin spinning={isLoadingNotes}>{userNotes}</Spin>
            )}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default AccountsOverviewNotesModal;
